<template>
    <v-dialog
      v-model="show"
      width= 50%
      outline
    >
      <v-card>
        <v-card-title class="text-h5" primary-title>
          Edit
        </v-card-title>
        <v-divider />
        <v-form ref="form">
          <v-card-text>
            <v-text-field
              data-testid="edit-call-disposition-name-input"
              class="edit-call-disposition-name-input"
              v-model="editObj.name"
              filled
              label="Enter name..."
              required
              :rules="inputRules"
            />
            <v-select
              v-if="editObj.dispositions"
              data-testid="edit-applicable-roles-menu"
              class="edit-applicable-roles-menu"
              v-model="assignedRoles"
              filled
              label="Select applicable roles..."
              multiple
              :items="availableRoles"
              required
            />
            <v-select
              v-if="!editObj.dispositions"
              data-testid="edit-call-type-menu"
              class="edit-call-type-menu"
              v-model="editObj.call_type_id"
              filled
              label="Select call type..."
              item-text="name"
              item-value="id"
              required
              :rules="inputRules"
              :items="callTypes"
            />
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-btn
              data-testid="edit-disposition-cancel-btn"
              class="edit-disposition-cancel-btn"
              color="error"
              @click.stop="show=false"
            >
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn
              data-testid="edit-disposition-save-btn"
              class="edit-disposition-save-btn"
              color="primary"
              @click="triggerEdit"
            >
              Save
            </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    availableRoles: {
      type: Array
    },
    callTypes: {
      type: Array
    },
    editObj: {
      type: [Object, String]
    },
    inputRules: {
      type: Array
    },
    value: {
      type: Boolean
    }
  },

  data() {
    return {
      hasLoaded: false
    };
  },

  methods: {
    triggerEdit() {
      return this.editObj.dispositions ? this.$emit("updateCallType") : this.$emit("updateDisposition");
    }
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    },

    assignedRoles: {
      get() {
        if (this.editObj && this.editObj.roles && this.editObj.roles.length && typeof this.editObj.roles[0] === "object") {
          return this.editObj.roles.map(role => role.id);
        }

        return this.editObj.roles;
      },

      set(newValue) {
        this.editObj.roles = newValue;
      }
    }
  }
};
</script>
